export class AppRoutingNames {
    public static readonly NAME_BASE = '';

    public static readonly ROUTE_BASE = `/${AppRoutingNames.NAME_BASE}`;
}
